import React, { useEffect, useRef } from 'react';

// Hooks
import { useNavigate } from 'react-router-dom';

// MUI Components
import { Box, Typography } from '@mui/material';

// Icons
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import CreditCardOutlinedIcon from '@mui/icons-material/CreditCardOutlined';
import FormatListBulletedOutlinedIcon from '@mui/icons-material/FormatListBulletedOutlined';

// Styles
import './styles.scss';

const CreateDropdown = (props) => {
  const { dropValue, setShowCreateDropDown } = props;
  const dropDownRef = useRef(null);
  const navigate = useNavigate();

  const createItems = [
    {
      id: 'create-order',
      name: 'Create order',
      path: '/orders/create-order',
      Icon: CreditCardOutlinedIcon,
    },
    {
      id: 'create-template',
      name: 'Create template',
      path: '/create-template',
      Icon: ArticleOutlinedIcon,
    },
    {
      id: 'create-list',
      name: 'Create list',
      path: '/contacts/import?origin=contacts',
      Icon: FormatListBulletedOutlinedIcon,
    },
  ];

  const handleItemClick = (item) => {
    navigate(item.path);
    setShowCreateDropDown(false);
  };

  useEffect(() => {
    let counter = 0;
    const handleClickOutside = (event) => {
      if (counter == 1 && dropDownRef.current && !dropDownRef.current.contains(event.target)) {
        setShowCreateDropDown(false);
      } else {
        counter = 1;
      }
    };

    if (dropValue == true) {
      window.addEventListener('click', handleClickOutside);
    }

    return () => {
      window.removeEventListener('click', handleClickOutside);
    };
  }, [dropValue, setShowCreateDropDown]);

  return (
    <Box ref={dropDownRef} className="createDropDownWrapper headerMenuSurface">
      <Box className="dropDownItems">
        {createItems.map((item) => (
          <button
            className="dropDownItem headerMenuItem"
            key={item.id}
            onClick={() => handleItemClick(item)}
            type="button"
          >
            <div className="imgOuter">
              <item.Icon aria-hidden="true" />
            </div>
            <Typography>{item.name}</Typography>
          </button>
        ))}
      </Box>
    </Box>
  );
};

export default CreateDropdown;
